var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoticonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9992 116C26.0188 116 0 89.9812 0 57.9992C0 26.0171 26.0188 0 57.9992 0C89.9796 0 116 26.0188 116 57.9992C116 89.9796 89.9812 116 57.9992 116ZM57.9992 4.06856C28.2577 4.06856 4.06857 28.2627 4.06857 57.9992C4.06857 87.7356 28.2627 111.925 57.9992 111.925C87.7356 111.925 111.931 87.7306 111.931 57.9925C111.931 28.2544 87.7373 4.06856 57.9992 4.06856Z",
    fill: "#70C4F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0069 66.1309H85.0945C85.355 66.2263 85.593 66.3693 85.7951 66.5519C85.9971 66.7345 86.1591 66.9529 86.2719 67.1948C86.3846 67.4367 86.4459 67.6973 86.4521 67.9616C86.4584 68.2259 86.4096 68.4888 86.3084 68.7353C81.8269 79.6658 70.932 86.729 58.5422 86.729C46.1524 86.729 35.266 79.6658 30.7845 68.7353C30.6836 68.4883 30.6351 68.225 30.642 67.9603C30.6488 67.6956 30.7108 67.4347 30.8244 67.1928C30.938 66.9508 31.1009 66.7324 31.3038 66.5502C31.5067 66.368 31.7457 66.2255 32.0069 66.1309Z",
    fill: "#70C4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9388 46.0607C45.5769 42.1644 42.9073 38.4932 38.9761 37.8607C35.0449 37.2283 31.3407 39.8741 30.7026 43.7704C30.0644 47.6666 32.734 51.3379 36.6652 51.9704C40.5965 52.6028 44.3006 49.957 44.9388 46.0607Z",
    fill: "#70C4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8055 46.0602C86.4436 42.1639 83.774 38.4927 79.8428 37.8602C75.9116 37.2278 72.2074 39.8736 71.5692 43.7699C70.9311 47.6662 73.6007 51.3374 77.5319 51.9699C81.4632 52.6023 85.1673 49.9565 85.8055 46.0602Z",
    fill: "#70C4F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoticonBlue);
export default __webpack_public_path__ + "static/media/emoticon-blue.207f0d398c5ad07a373d6fd043430dbd.svg";
export { ForwardRef as ReactComponent };